import React, { useState, useRef, useEffect } from 'react';
import { SelectItem } from 'src/models/common/SelectItem';

export interface ISelectCommonProps {
    label?: string;
    selectStyle?: 'input' | 'link';
    style?: React.CSSProperties;
    className?: string;
    items?: SelectItem[];
}

interface ISelectBaseProps extends ISelectCommonProps {
    onChange?: (item: SelectItem) => void;
}

const SelectBaseInner: React.FC<ISelectBaseProps> = React.forwardRef((props, ref) => {
    const dropdownRef = useRef(null);
    const parentRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = (e: MouseEvent) => {
        if ((dropdownRef.current && dropdownRef.current.contains(e.target)) || (parentRef.current && parentRef.current.contains(e.target))) {
            return;
        }

        setIsOpen(false);
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleItemSelect = (item: SelectItem) => {
        if (item.id !== 0) {
            if (props.onChange) {
                props.onChange(item);
            }
            setIsOpen(false);
        }
    };

    const items = () => {
        if (props.items) {
            return props.items.map((item: SelectItem, index: number) => {
                let icon = item.icon;
                if (icon && icon.indexOf('down') > 0) {
                    icon += '-alt';
                }

                if (item.id === 0) {
                    return <div style={{ height: '.5rem', borderBottom: '1px solid #ccc', width: '90%', margin: '0 auto .5rem auto' }} />;
                }

                return (
                    <div key={`item-${item.id}`} className="item" onClick={() => handleItemSelect(item)}>
                        {item.icon && (
                            <span className="item-icon">
                                <i className={`fas fa-sort-${icon}`} />
                            </span>
                        )}
                        <span data-text={item.name} className="item-text">
                            {item.name}
                        </span>
                    </div>
                );
            });
        }
        return undefined;
    };

    let textClass = 'dlc-form-select';
    if (props.selectStyle && props.selectStyle === 'link') {
        textClass = 'dlc-form-select link';
    }

    return (
        <div className="dlc-form-select-wrapper" style={props.style}>
            <div className={textClass} ref={parentRef} onClick={toggleDropdown} style={{ padding: '.25rem 1rem .75rem 1rem' }}>
                {props.label}
            </div>
            {isOpen && (
                <div ref={dropdownRef} className="dlc-form-select-dropdown2">
                    {items()}
                </div>
            )}
        </div>
    );
});

SelectBaseInner.defaultProps = {
    selectStyle: 'input',
};

const SelectBase = React.memo(SelectBaseInner);
export default SelectBase;



// WEBPACK FOOTER //
// ./src/components/controls/forms/base/SelectBase.tsx